import { BaseProductComponent } from '../base-product-component';
import { ProductData, PPSSState, CalculationTypeOption } from '@types';

export class PpssTableBase extends BaseProductComponent {
  sortedTableRows: ProductData[] = [];
  showNoResultsMessage: boolean;
  config: any;
  initialCalc: string;
  firstTime = true;

  constructor() {
    super();
  }

  /**
   * Called when the state changes.
   */
  onPopulate(newState: PPSSState) {
    const hasLoadedFullFeed = newState && newState.hasLoadedFullFeed;

    if (!hasLoadedFullFeed) {
      this.isPopulated = false;
      return;
    }

    this.config = newState.config;
    this.sortedTableRows = newState.data.tableRows.slice(0);
    this.showNoResultsMessage =
      this.sortedTableRows && this.sortedTableRows.length === 0;
    this.isPopulated = true;
  }

  /**
   * Check tab active status (for AACR)
   */
  _checkCalcStatus(tabs: CalculationTypeOption[], currentTab: string) {
    return tabs.map((tab) => {
      tab.isActive = tab.key === currentTab;
      return tab;
    });
  }
}
